import SectionTypeViewmodel from "./SectionTypeViewmodel";

export default class CreateProjectViewmodel {
    public name: string = '';
    public instructingParty: number = 0;
    public managingConsultant: string = '';
    public sections: SectionTypeViewmodel[] = [];
}